module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "d-flex mb-4 section-title-container wrap txt-center align-center"
  }, [_c('billing-buy-car-svg'), _vm._v(" "), _c('h2', {
    staticClass: "uppercase bold section-title",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("Facturación")])], 1), _vm._v(" "), _c('p', {
    staticClass: "mx-1"
  }, [_vm._v("Activa esta opción para solicitar factura. No aplican productos que indicaban \"No se emite factura\".")]), _vm._v(" "), _c('p', {
    staticClass: "bold mx-1"
  }, [_vm._v("Estimado cliente, recuerda que solamente recibirás factura sobre compras realizadas a Que Tal Compra o a sellers obligados a facturar. Gracias!")]), _vm._v(" "), _c('el-switch', {
    staticClass: "my-3 mx-1",
    attrs: {
      "active-text": _vm.labelByCountry,
      "active-color": _vm.activeColor
    },
    on: {
      "input": _vm.changeActiveBill
    },
    model: {
      value: (_vm.activeBilling),
      callback: function($$v) {
        _vm.activeBilling = $$v
      },
      expression: "activeBilling"
    }
  }), _vm._v(" "), (_vm.activeBilling) ? _c('form', {
    staticClass: "d-flex wrap"
  }, [_c('div', {
    staticClass: "content-type-document flex-45 mx-1 mb-1"
  }, [(_vm.isEcuador) ? _c('select-component', {
    staticClass: "select-component",
    attrs: {
      "placeholder": "Tipo de Documento",
      "item-text": "name",
      "item-value": "code",
      "options": _vm.typeDocuments
    },
    model: {
      value: (_vm.billing.documentType),
      callback: function($$v) {
        _vm.$set(_vm.billing, "documentType", $$v)
      },
      expression: "billing.documentType"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-45 mx-1 mb-1",
    attrs: {
      "prop": "ruc"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "placeholder": "Número de Documento"
    },
    on: {
      "input": _vm.checkingFalgValidDocumentNumber,
      "blur": _vm.onBlur
    },
    model: {
      value: (_vm.billing.ruc),
      callback: function($$v) {
        _vm.$set(_vm.billing, "ruc", $$v)
      },
      expression: "billing.ruc"
    }
  }), _vm._v(" "), (_vm.$v.flagValidDocumentNumber.$invalid && _vm.$v.billing.ruc.required) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("Documento " + _vm._s(_vm.rucWordByCountry))]) : _vm._e(), _vm._v(" "), (_vm.$v.billing.ruc.$invalid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("Documento requerido.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-45 mx-1 mb-1",
    attrs: {
      "prop": "rzSocial"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "placeholder": _vm.rzSocialLabel
    },
    on: {
      "input": _vm.validateForm
    },
    model: {
      value: (_vm.billing.rzSocial),
      callback: function($$v) {
        _vm.$set(_vm.billing, "rzSocial", $$v)
      },
      expression: "billing.rzSocial"
    }
  }), _vm._v(" "), (!_vm.$v.billing.rzSocial.required) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("La razón social es requerida")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-95 mx-1 mb-1",
    attrs: {
      "prop": "address"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "placeholder": "Dirección del domicilio fiscal"
    },
    on: {
      "input": _vm.validateForm
    },
    model: {
      value: (_vm.billing.address),
      callback: function($$v) {
        _vm.$set(_vm.billing, "address", $$v)
      },
      expression: "billing.address"
    }
  }), _vm._v(" "), (!_vm.$v.billing.address.required) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("La dirección es requerida")]) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02de93ba","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy/billing.vue
// module id = 1063
// module chunks = 33